import { Daterange } from '@northfork/ng-basics'
import { PayloadAction, createSlice } from '@reduxjs/toolkit'
import {
  ExtFileManagerFilter,
  persistentStateFeatureKey,
} from './persistent-state.models'

export type PersistentRedux = {
  extFileViewerDateRange?: Daterange
  extFileManagerFilter: ExtFileManagerFilter
}

export const persistentInitialState: PersistentRedux = {
  extFileViewerDateRange: undefined,
  extFileManagerFilter: {
    accountId: undefined,
    activePanelId: 1,
    executionNumber: undefined,
    selectedDate: undefined,
  },
}

export const persistentStateSlice = createSlice({
  name: persistentStateFeatureKey,
  initialState: persistentInitialState,
  reducers: {
    setExtFileViewerDateRangeFilter: (
      oldState,
      action: PayloadAction<Daterange>,
    ) => ({
      ...oldState,
      extFileViewerDateRange: {
        ...action.payload,
      },
    }),

    setExtFileManagerFilter: (
      oldState,
      action: PayloadAction<ExtFileManagerFilter>,
    ) => {
      return {
        ...oldState,
        extFileManagerFilter: {
          ...oldState.extFileManagerFilter,
          ...action.payload,
        },
      }
    },
  },
})

export const { setExtFileViewerDateRangeFilter, setExtFileManagerFilter } =
  persistentStateSlice.actions

export default persistentStateSlice.reducer
